<!--
 * @Author: 汪俊洪
 * @Date: 2025-04-25 13:32:21
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-06-16 17:40:09
 * @Description:
-->
<template>
  <div class="page">
    <div class="content">
      <Search
        :type="type"
        ref="search"
        @changeType="changeType"
        @reset="reset"
        @doSearch="reset"
      />
      <!-- 主体内容 -->
      <div class="plc-content">
        <List
          v-if="type === 'list'"
          @changeNum="changeNum"
          :tableData="tableData"
          :loading="loading"
        />
        <ImgList
          v-if="type === 'img'"
          :loading="loading"
          :tableData="tableData"
        />
      </div>
      <!-- 底部内容 -->
      <div class="plc-bottom">
        <!-- 底部内容1 -->
        <div class="plc-bottom1" v-if="type === 'list'">
          <div class="plc-bottom1-left">
            已选择<span>{{ Object.keys(selectedObj).length }}</span
            >种，共<span>{{ totalNum }}</span
            >件
          </div>
          <div class="plc-bottom1-right">
            <div @click="toAdd" class="btn to-buy">直接下单</div>
            <div @click="toCar" :loading="carLoading" class="btn">加入购物车</div>
          </div>
        </div>
        <!-- 底部内容2 分页内容 -->
        <div class="plc-pagination">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, prev, pager, next, sizes, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Search from './components/search.vue'
import List from './components/list.vue'
import ImgList from './components/imgList.vue'
import { add, mul } from '@/utils/numberComputed'

export default {
  components: {
    Search,
    List,
    ImgList
  },
  data () {
    return {
      type: localStorage.getItem('plcType') || 'img', // list, img
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      selectedObj: {}, // 选中的数据
      totalNum: 0,
      loading: false,
      carLoading: false
    }
  },
  mounted () {
    this.doSearch()
  },
  methods: {
    // 直接下单
    toAdd () {
      if (Object.keys(this.selectedObj).length === 0) {
        return this.$message.warning('请选择商品')
      }
      const itemList = []
      Object.keys(this.selectedObj).forEach((k) => {
        itemList.push({
          ...this.selectedObj[k]
        })
      })
      const t = new Date().getTime()
      const obj = {
        t,
        itemList: itemList.map((v) => {
          return {
            ...v,
            discountSellingPriceTotal: mul(v.discountSellingPrice, v.goodsNum)
          }
        })
      }
      sessionStorage.setItem('plcOrderAdd', JSON.stringify(obj))
      this.$router.push({
        path: '/plcOrderAdd',
        query: {
          t
        }
      })
    },
    toCar () {
      if (Object.keys(this.selectedObj).length === 0) {
        return this.$message.warning('请选择商品')
      }
      const itemList = []
      Object.keys(this.selectedObj).forEach((k) => {
        itemList.push({
          goodsNum: this.selectedObj[k].goodsNum,
          plcSkuId: this.selectedObj[k].plcSkuId
        })
      })
      this.carLoading = true
      this.$http.post('/front/oms/plc/shoppingCart/addShoppingCartSkuBatch', {
        itemList
      }).then(({ data: res }) => {
        this.carLoading = false
        if (res.code === 0) {
          this.$message({
            type: 'success',
            duration: 1500,
            message: '添加购物车成功'
          })
          this.bus.$emit('getCurrentUserCount')
        }
      })
    },
    // 选中的数据
    changeNum (row) {
      if (row.goodsNum > 0) {
        this.selectedObj[row.skuId] = row
      } else {
        delete this.selectedObj[row.skuId]
      }
      this.selectedObj = {
        ...this.selectedObj
      }
      this.computedNum()
    },
    computedNum () {
      let totalNum = 0
      Object.keys(this.selectedObj).forEach((key) => {
        if (this.selectedObj[key].goodsNum > 0) {
          totalNum = add(totalNum, this.selectedObj[key].goodsNum)
        }
      })
      this.totalNum = totalNum
    },
    // 切换类型
    changeType (t) {
      this.type = t
      localStorage.setItem('plcType', t)
      this.currentPage = 1
    },
    handleSizeChange (val) {
      this.currentPage = 1
      this.pageSize = val
      this.doSearch()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.doSearch()
    },
    reset () {
      this.currentPage = 1
      this.doSearch()
    },
    doSearch () {
      const obj = {
        limit: this.pageSize,
        page: this.currentPage,
        ...this.$refs.search.dataForm
      }
      console.log(obj)
      this.loading = true
      this.$http
        .post('/front/oms/plc/commoditySku/pageCommoditySkuList', obj)
        .then(({ data: res }) => {
          this.loading = false
          if (res.code !== 0) {
            return
          }
          let { records, total, size, current } = res.data
          this.total = total - 0
          this.pageSize = size - 0
          this.currentPage = current - 0
          if (this.type === 'list') {
            records = records.map((v) => {
              return {
                ...v,
                goodsNum: this.selectedObj[v.skuId] ? this.selectedObj[v.skuId].goodsNum : undefined
              }
            })
          }
          this.tableData = records
        }).catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  height: 100%;
  padding: 16px 0;
}
.content {
  display: flex;
  flex-direction: column;
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  background: #fff;
  .plc-content {
    flex: 1;
    overflow: hidden;
  }
}

.plc-bottom {
  .plc-bottom1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 9.5px 16px;
  }
  .plc-bottom1-left {
    font-size: 12px;
    color: #000;
    span {
      color: #ff0000;
    }
  }
  .plc-bottom1-right {
    display: flex;
    align-items: center;
    .btn {
      font-size: 18px;
      font-weight: bold;
      line-height: 20px;
      margin-left: 12px;
      padding: 8px 12px;
      background: #2a54d1;
      border-radius: 8px;
      color: #fff;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
      &.to-buy {
        background: #ff4c2b;
      }
    }
  }
  .plc-pagination {
    border-top: 1px solid #eeeeee;
  }
}
</style>
